module.exports = __webpack_public_path__ + "Roboto-ThinItalic.woff?4ced2a97efbc5f12663c750fbc318e83";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/ThinItalic/Roboto-ThinItalic.woff?v=2.137
// module id = 684
// module chunks = 7